import { useState, useEffect } from 'react'
import { useNavigate } from "react-router-dom";
import "./Modal.css";
import axios from 'axios';
import { encryptString } from "../../../utils/apiUtils";
import { v4 as uuidv4 } from 'uuid';

export const AbhaVerifyOtp = ({ showAbhaVerifyOtp, closeVerifyOtpModal, AbhaTxnId, setshowAbhaVerifyOtp, redirectUrl }) => {
    const navigate = useNavigate(); // React Router hook for navigation
    const [encryptAbhaOtp, setencryptAbhaOtp] = useState(null);
    const [accessToken, setAccessToken] = useState("");
    const [DisplayValue, setDisplayValue] = useState("");
    const [MobileNumber, setMobileNumber] = useState("");
    const [abdmAbhaOtp, setotp] = useState(new Array(6).fill(""));
    const [OtpText, setOtpText] = useState("");
    const [ErrorMessage, setErrorMessage] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    // const [resendTimer, setResendTimer] = useState(0); // Timer starts from 30 seconds

    const maskNumber = (num) => {
        // Split the number into parts based on the delimiter '-'
        const parts = num.split("-");
        // Mask all but the last group
        const maskedParts = parts.map((part, index) =>
            index === parts.length - 1 ? part : part.replace(/./g, "X")
        );
        // Join the parts back with the delimiter
        return maskedParts.join("-");
    };

    const handleChange = (value, index) => {
        if (!/^\d*$/.test(value)) return; // Allow only numeric values

        const newOtp = [...abdmAbhaOtp];
        newOtp[index] = value;

        setotp(newOtp);

        // Convert OTP array to text and set it to OtpText
        const otpAsText = newOtp.join(""); // Joins all the digits into a single string
        setOtpText(otpAsText);

        // Automatically move to the next input field
        if (value && index < 5) {
            document.getElementById(`otp-input-${index + 1}`).focus();
        }
    };

    const handleInputChange = (e) => {
        const inputValue = e.target.value;

        // Remove non-numeric characters
        const numericValue = inputValue.replace(/\D/g, "");

        // Format the value as xx-xxxx-xxxx-xxxx
        const formattedValue = numericValue.replace(
            /^(\d{0,2})(\d{0,4})(\d{0,4}).*/,
            (match, p1, p2, p3, p4) => [p1, p2, p3, p4].filter(Boolean).join("-")
        );

        // Update state
        setDisplayValue(formattedValue);
        setMobileNumber(numericValue);
    };

    const handleBackspace = (e, index) => {
        if (e.key === "Backspace" && !abdmAbhaOtp[index] && index > 0) {
            document.getElementById(`otp-input-${index - 1}`).focus();
        }
    };

    const verifyOtp = async () => {
        const Backend_token = localStorage.getItem('Backend_token');
        const data = {
            request: {
                authData: {
                    authMethods: ["otp"],
                    otp: {
                        txnId: AbhaTxnId,
                        otpValue: encryptAbhaOtp,
                        mobile: MobileNumber,
                    },
                },
                consent: {
                    code: "abha-enrollment",
                    version: "1.4",
                },
            },
            header: {
                'Content-Type': 'application/json',
                'REQUEST-ID': uuidv4(),
                'TIMESTAMP': new Date().toISOString(), // Generate the current timestamp dynamically
                'Authorization': 'Bearer ' + accessToken, // Replace with a valid token
            }

        };
        try {
            const response = await axios.post(
                "/abdm/verifyOtp",
                data,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + Backend_token, // Replace with a valid token
                    },
                }
            );
            return response.data;
        } catch (error) {
            setErrorMessage("Something went wrong!!");
            setIsLoading(false);
        } finally {
            //console.log('error');
        }
    };

    // Trigger when accessToken changes
    useEffect(() => {
        const sendOtpIfReady = async () => {
            if (accessToken && encryptAbhaOtp) {
                const abhaOtpResponse = await verifyOtp();
                if (abhaOtpResponse?.txnId) {
                    if (abhaOtpResponse?.ABHAProfile) {
                        const base64Prefix = "data:image/png;base64,";
                        const base64String = abhaOtpResponse.ABHAProfile.photo
                            ? base64Prefix + abhaOtpResponse.ABHAProfile.photo
                            : (abhaOtpResponse.ABHAProfile.gender == 'M') ? '/images/male.svg' : (abhaOtpResponse.ABHAProfile.gender == 'F') ? '/images/female.svg' : 'Other';

                        let dob = abhaOtpResponse.ABHAProfile.dob;
                        let [day, month, year] = dob.split("-");
                        let formattedDate = `${year}-${month}-${day}`;
                        let yearOfBirth = new Date(formattedDate).getFullYear();

                        const beneficiaryDetails = {
                            name: abhaOtpResponse.ABHAProfile.firstName + ' ' + abhaOtpResponse.ABHAProfile.middleName + ' ' + abhaOtpResponse.ABHAProfile.lastName,
                            abhaNo: maskNumber(abhaOtpResponse.ABHAProfile.ABHANumber),
                            originalabha: abhaOtpResponse.ABHAProfile.ABHANumber,
                            hid: abhaOtpResponse.ABHAProfile.preferredAbhaAddress,
                            hidn: abhaOtpResponse.ABHAProfile.ABHANumber,
                            address: abhaOtpResponse.ABHAProfile.address,
                            mobile: abhaOtpResponse.ABHAProfile.mobile.slice(0, -4).replace(/./g, "X") + abhaOtpResponse.ABHAProfile.mobile.slice(-4),
                            originalmobile: abhaOtpResponse.ABHAProfile.mobile,
                            dob: abhaOtpResponse.ABHAProfile.dob,
                            yearOfBirth: 'XX-XX-' + yearOfBirth,
                            gender: (abhaOtpResponse.ABHAProfile.gender == 'M') ? 'Male' : (abhaOtpResponse.ABHAProfile.gender == 'F') ? 'Female' : 'Other',
                            kycphoto: base64String,
                            profilePhoto: abhaOtpResponse.ABHAProfile?.profilePhoto,
                            originalKycPhoto: abhaOtpResponse.ABHAProfile?.kycPhoto,
                            preferredAbhaAddress: abhaOtpResponse.ABHAProfile?.preferredAbhaAddress,
                            email: abhaOtpResponse.ABHAProfile?.email,
                            abhaNumber: abhaOtpResponse.ABHAProfile?.ABHANumber,
                            statelgd: abhaOtpResponse.ABHAProfile?.stateCode,
                            districtlgd: abhaOtpResponse.ABHAProfile?.districtCode,
                            mobileOriginal: abhaOtpResponse.ABHAProfile?.mobile,
                        };
                        const orignalBeneficiaryData = {
                            distlgd: abhaOtpResponse.ABHAProfile.districtCode,
                            district_name: abhaOtpResponse.ABHAProfile.districtName,
                            dob: abhaOtpResponse.ABHAProfile.dob,
                            gender: abhaOtpResponse.ABHAProfile.gender,
                            fullgendername: (abhaOtpResponse.ABHAProfile.gender == 'M') ? 'Male' : (abhaOtpResponse.ABHAProfile.gender == 'F') ? 'Female' : 'Other',
                            hid: abhaOtpResponse.ABHAProfile.email,
                            hidn: abhaOtpResponse.ABHAProfile.ABHANumber,
                            mobile: abhaOtpResponse.ABHAProfile.mobile,
                            name: abhaOtpResponse.ABHAProfile.firstName + ' ' + abhaOtpResponse.ABHAProfile.middleName + ' ' + abhaOtpResponse.ABHAProfile.lastName,
                            statename: abhaOtpResponse.ABHAProfile.stateName,
                            statelgd: abhaOtpResponse.ABHAProfile.stateCode,
                            address: abhaOtpResponse.ABHAProfile.address,
                            kycphoto: base64String,
                            profilePhoto: abhaOtpResponse.ABHAProfile?.profilePhoto,
                            originalKycPhoto: abhaOtpResponse.ABHAProfile?.kycPhoto,
                            preferredAbhaAddress: abhaOtpResponse.ABHAProfile?.preferredAbhaAddress,
                            email: abhaOtpResponse.ABHAProfile?.email,
                            abhaNumber: abhaOtpResponse.ABHAProfile?.ABHANumber,
                            statelgd: abhaOtpResponse.ABHAProfile?.stateCode,
                            districtlgd: abhaOtpResponse.ABHAProfile?.districtCode,
                            mobileOriginal: abhaOtpResponse.ABHAProfile?.mobile,
                        }
                        localStorage.setItem("beneficiaryDetails", JSON.stringify(beneficiaryDetails));
                        localStorage.setItem("orignalBeneficiaryData", JSON.stringify(orignalBeneficiaryData));
                        localStorage.removeItem("NCD_Searchdetails");
                        localStorage.removeItem("NIKSHAY_Registration_Detials");
                        localStorage.removeItem("NIKSHAY_NEW_PROFILE");
                        setIsLoading(false);
                        setshowAbhaVerifyOtp(false);
                        navigate(redirectUrl || "/detailsabha");

                    }
                } else {
                    setIsLoading(false);
                    setErrorMessage(abhaOtpResponse?.message || "Failed to send OTP. Please try again.");
                }
            }
        };
        sendOtpIfReady();
    }, [accessToken, encryptAbhaOtp]);

    const handleCreateAbha = async () => {

        try {
            setIsLoading(true);
            setAccessToken(localStorage.getItem("abdmAccessToken"));
            const encryptedOtp = await encryptString(OtpText);
            if (!encryptedOtp) {
                setIsLoading(false);
                setErrorMessage("Encryption failed. Please try again.");
                return;
            }
            setencryptAbhaOtp(encryptedOtp);
        } catch (error) {
            setIsLoading(false);
            setErrorMessage("An unexpected error occurred.");
            console.error("Error in handleCreateAbha:", error);
        }
    };

    return (
        <>

            {showAbhaVerifyOtp && (
                <div className="modal fade show d-block verificationModel addPatentModel" id="exampleModal" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true" style={{ background: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header border-bottom-0 ">
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={closeVerifyOtpModal} />
                            </div>
                            <div className="modal-body">
                                <div className="row Abharow">
                                    <div className="col-md-6 text-center">
                                        <img src="/images/Abha.svg" alt="" className="abhaLogo" />
                                        <h2>Enter OTP</h2>
                                    </div>
                                    <div className="col-md-6 text-left">
                                        <label className="header_text">Enter OTP:</label>
                                        {ErrorMessage && (
                                            <p className="error-message-modal">{ErrorMessage}</p>
                                        )}

                                        <div style={{ display: "flex", gap: "20px" }}>
                                            {Array.isArray(abdmAbhaOtp) &&
                                                abdmAbhaOtp.map((value, index) => (
                                                    <input
                                                        key={index}
                                                        id={`otp-input-${index}`}
                                                        type="text"
                                                        maxLength="1"
                                                        name="abdmAbhaOtp"
                                                        autoComplete="off"
                                                        value={value}
                                                        onChange={(e) => handleChange(e.target.value, index)}
                                                        onKeyDown={(e) => handleBackspace(e, index)}
                                                        className="form-control"
                                                        style={{
                                                            width: "40px",
                                                            height: "40px",
                                                            textAlign: "center",
                                                            fontSize: "18px",
                                                            padding: "0",
                                                            lineHeight: "40px"
                                                        }}
                                                    />
                                                ))}
                                        </div>
                                        <div>
                                            <input type="text" maxLength="12" name="abdmAbhaOtp" className="form-control" value={DisplayValue} onChange={handleInputChange} placeholder='Mobile Number' style={{ height: "50px", fontSize: "14px", }} />
                                        </div>
                                        <div className="modal-buttons">
                                            <button
                                                className="btn btn btn-primary btn-prim border-0"
                                                style={{
                                                    backgroundColor: Array.isArray(abdmAbhaOtp) && abdmAbhaOtp.every((val) => val !== "")
                                                        ? "#3FC4F4"
                                                        : "#A9A9A9",
                                                    color: "white",
                                                }}
                                                onClick={handleCreateAbha}
                                                disabled={
                                                    (Array.isArray(abdmAbhaOtp) && !abdmAbhaOtp.every((val) => val !== "")) || isLoading
                                                }
                                            >
                                                {isLoading ? "Processing..." : "Submit"}
                                            </button>
                                            {/* <button className="btn btn-primary" onClick={resendOtp} disabled={resendTimer > 0} > {resendTimer > 0 ? `Resend OTP in ${resendTimer}s` : "Resend OTP"} </button> */}
                                        </div>
                                    </div>

                                </div>
                            </div>
                            {/* <div className="modal-footer">
                            <button className="cancel" onClick={closeVerifyOtpModal}>Cancel</button>
                            <button className="submit">Submit</button>
                        </div> */}
                        </div>
                    </div>
                </div>
            )}

            {/* <Modal show={showAbhaVerifyOtp} handleClose={closeVerifyOtpModal}>

            </Modal> */}
        </>
    )
}